module.exports = __webpack_public_path__ + "static/media/mediumIcon.8da10605.svg";